import getCookieConsentPreferences, {
  gpcSignal,
} from "../../utils/cookie-consent"

function getConsentsData() {
  const cookieConsentPreferences = getCookieConsentPreferences()
  return {
    "Necessary cookies":
      cookieConsentPreferences?.personalization_storage || "ignored",
    "Preferences cookies":
      cookieConsentPreferences?.functional_storage || "ignored",
    "Statistics cookies":
      cookieConsentPreferences?.analytics_storage || "ignored",
    "Marketing cookies": cookieConsentPreferences?.ad_storage || "ignored",
    "Has GPC enabled": gpcSignal,
  }
}

async function waitConsentsData(): Promise<ReturnType<typeof getConsentsData>> {
  const maxRetries = 30
  const retryInterval = 100
  async function wait(t: number) {
    return new Promise(resolve => setTimeout(resolve, t))
  }

  let retries = 0
  while (retries < maxRetries) {
    const cookieConsentPreferences = getCookieConsentPreferences()
    if (cookieConsentPreferences !== null) {
      return getConsentsData()
    }
    await wait(retryInterval)
    retries++
  }

  return getConsentsData()
}

export { getConsentsData, waitConsentsData }
export default waitConsentsData
